import moment from 'moment';

export const formatDate =  (date?: string, placeholder: string = '-') =>
  date ? moment(date).format('DD/MM/YYYY') : placeholder;
